import * as React from "react";
import PropTypes from "prop-types";
import { useAutocomplete } from "@mui/core/AutocompleteUnstyled";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Card from "react-bootstrap/Card";
import axios from 'axios';
import TuneIcon from '@mui/icons-material/Tune';
import { I18nPropvider, LOCALES } from './../i18nProvider';
import { FormattedMessage } from 'react-intl';
import makeStyles from "@material-ui/core/styles/makeStyles";


const Root = styled("div")(
  ({ theme }) => `
  color: ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.65)" : "rgba(0,0,0,.85)"
    };
  font-size: 14px;
`
);

/******************* Barre de recherche *******************/
const InputWrapper = styled("div")(
  ({ theme }) => `
  border: 1px solid ${theme.palette.mode === "dark" ? "#434343" : "#d9d9d9"};
  background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
  }

  &.focused {
    border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
    color: ${theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.65)"
      : "rgba(0,0,0,.85)"
    };
    height: 56px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`
  /* &:empty:not(:focus):before{
    content:attr(data-placeholder);
    color: #555;
  } */
);

function Tag(props) {
  const { label, val, onDelete, ...other } = props;
  return (
    <div {...other}>
      <span className="autoCompleteType">{label}</span>
      <span className="autoCompleteValue">{val}</span>
      <CloseIcon onClick={onDelete} className="blue-color" />
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired
};
/******************* Case avec package: value ou channel: value *******************/
const StyledTag = styled(Tag)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "#D1EDFB"
    };
  border: 1px solid ${theme.palette.mode === "dark" ? "#303030" : "#e8e8e8"};
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
    background-color: ${theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"};
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  /****** croix pour fermer dans le champ de recherche ******/
  & svg {
    font-size: 22px;
    cursor: pointer;
    padding: 4px;
  }
`
);

const Listbox = styled("ul")(
  ({ theme }) => `
  width:400px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;
  cursor: default;

  & li {
    padding: 5px 12px;
    display: flex;
    
    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected='true'] {
    background-color: ${theme.palette.mode === "dark" ? "#2b2b2b" : "#fafafa"};
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li[data-focus='true'] {
    background-color: ${theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"};
    cursor: pointer;

    & svg {
      color: currentColor;
    }
  }
  
  & ul {
    font-weight: bold;
  }
  `
);

const useStyles = makeStyles({
  customTextField: {
    "& input::placeholder": {
      fontSize: "20px"
    }
  }
});

//modifie le format d'affichage des positions orbitales dans la liste déroulante
function formatOrbitalPosition(orbitalPosition) {
  if (orbitalPosition != null) {
    if (orbitalPosition !== undefined) {
      var data = orbitalPosition.split("°");
      var value = data[0].trim();
      var position = data[1];
      if (position == "E") {
        position = "East"
      } else if (position == "W") {
        position = "West"
      }
      orbitalPosition = parseFloat(value) + "° " + position;
    } else {
      orbitalPosition = "";
    }

  } else {
    orbitalPosition = "";
  }
  return orbitalPosition;
}

function unFormatOrbitalPosition(orbitalPosition) {
  if (orbitalPosition !== "") {
    if (orbitalPosition !== undefined) {
      var data = orbitalPosition.split("°");
      var value = data[0].trim();
      var position = data[1].trim();
      if (position == "EAST") {
        position = "E"
      } else if (position == "WEST") {
        position = "W"
      }
      orbitalPosition = parseFloat(value).toFixed(2) + "°" + position;
    }
  }
  return orbitalPosition;
}


function resetListSatellites(props) {
  document.getElementById("satellite").value = "";
  document.getElementById("orbitalPosition").value = "";
  axios.get('/lineup/api/satellite/actif').then(res => { props.refreshSatellite(res.data); })
}

function resetSearchForm(props) {
  document.getElementById("search-form").reset();
}

function rechercher(props) {
  props.onSearchLoading(true)
  const checkboxesChannelResolution = document.querySelectorAll('input[name="channelResolution"]:checked');
  let channelResolution = [];
  checkboxesChannelResolution.forEach((checkbox) => {
    channelResolution.push(checkbox.value);
  });


  const checkboxesChannelEncryption = document.querySelectorAll('input[name="channelEncryption"]:checked');
  let channelEncryption = [];
  checkboxesChannelEncryption.forEach((checkbox) => {
    channelEncryption.push(checkbox.value);
  });

  const checkboxesServiceType = document.querySelectorAll('input[name="serviceType"]:checked');
  let type = [];
  checkboxesServiceType.forEach((checkbox) => {
    type.push(checkbox.value);
  });


  var channels = [];
  props.value.filter(item => item.type === "channel").map(item => channels.push(item.value))
  var packages = [];
  props.value.filter(item => item.type === "package").map(item => packages.push(item.value))


  var satelliteName = document.getElementById("satellite").value;
  var orbitalPosition = unFormatOrbitalPosition(document.getElementById("orbitalPosition").value);
  var language = document.getElementById("language").value;
  var theme = document.getElementById("genre").value;


  if (satelliteName === '') {
    satelliteName = null;
  }
  if (orbitalPosition === '') {
    orbitalPosition = null;
  }
  if (language === '') {
    language = null;
  }
  if (theme === '') {
    theme = null;
  }

  const searchCriteria = {
    channels: channels,
    packages: packages,
    satelliteName: satelliteName,
    channelResolution: channelResolution,
    channelEncryption: channelEncryption,
    orbitalPosition: orbitalPosition,
    language: language,
    theme: theme,
    type: type
  };

  //console.log(props.searchLoading)
  axios.post('/lineup/api/lineup/lineup-searches/', searchCriteria).then(res => { props.onChangeValue(res.data); props.onSearchLoading(false) }) // '/lineup/api/lineup/lineup-searches/'
}

function findOrbitalePositionBySatelliteName(props) {
  var satelliteName = document.getElementById("satellite").value;
  axios.get('/lineup/api/satellite/orbitalPosition/?satelliteName=' + satelliteName).then(res => { props.onChangeSatelliteNameValue(res.data); })

}

function findSatelliteByOrbitalePosition(props) {
  var orbitalPosition = unFormatOrbitalPosition(document.getElementById("orbitalPosition").value);
  axios.get('/lineup/api/satellite/satellite/?orbitalPosition=' + orbitalPosition).then(res => { props.onChangeOrbitalPostion(res.data); })

}

function afficherRechercheAvancee() {
  let rechercheAvancee = document.getElementById("rechercheAvancee");
  if (getComputedStyle(rechercheAvancee).display !== "none") {
    rechercheAvancee.style.display = "none";
  } else {
    rechercheAvancee.style.display = "flex";
  }
}



function FormulaireRecherche(props) {
  const { satelitteData, lineUpData, autoCompleteData, onChangeValue, onChangeSatelliteNameValue, languages, themes, locale, orbitalePositionData, onChangeOrbitalPostion, refreshSatellite, searchLoading, onSearchLoading } = props;
  const {
    getRootProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl
  } = useAutocomplete(
      {
        id: "customized-hook-demo",
        multiple: true,
        options: autoCompleteData,
        getOptionLabel: (option) => option.value,

      }
  );
  var group = 'undefined';
  const formatGroup = name => {
    if (name && name.length > 1) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
    return null;
  };



  return (
    <Root>
      <I18nPropvider locale={locale}>
        <Container>
          <div className="titres">
            <h1 className="channelHomeTitle">Channel Line-Up</h1>
            <br />
            <h1 className="homeTitle"><FormattedMessage id="homeTitle1" /></h1>
            <h1 className="homeTitle"><FormattedMessage id="homeTitle2" /></h1>
          </div>
          <br />
          <Form id="search-form">
            <Row className="align-items-center">
              <div className="col-12 col-md-8">
                <div {...getRootProps()}>
                  <InputWrapper id="field" ref={setAnchorEl} className={focused ? "focused" : ""} >
                    {/** Ce qui est affiché dans la barre de recherche une fois la chaine ou le package séléctionné */}
                    {value.map((result, index) => (
                      <StyledTag label={result.type + ":"} val={" " + result.value}  {...getTagProps({ index })} />
                    ))}
                    <input placeholder="Search for any channel or package" {...getInputProps()}
                    />
                  </InputWrapper>
                </div>
                {groupedOptions.length > 0 ? (

                  <Listbox {...getListboxProps()}>
                    {
                      groupedOptions.map((option, index) => {
                        if (option.type === group) {
                          group = option.type;
                          return (
                              <li {...getOptionProps({option, index})}
                                  key={option.id}>
                                <span key={option.id}>{option.value}</span>
                                <CheckIcon key={option.id} fontSize="small"/>
                              </li>
                          )
                        } else {
                          group = option.type;
                          return (
                              <React.Fragment>
                              <ul>{formatGroup(option.type)}</ul>
                          <li {...getOptionProps({option, index})}
                              key={option.id}>
                            <span key={option.id}>{option.value}</span>
                            <CheckIcon key={option.id} fontSize="small"/>
                          </li>
                              </React.Fragment>
                          )

                        }

                      }
                    )
                    }

                  </Listbox>
                ) : null}
              </div>

              <div className="col-8 col-md-2 mobileFormat">
                <Button type="button" className="searchButton" onClick={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })} size="small"><FormattedMessage id="search" /></Button>
              </div>
              <div className="col-2 col-md-2 mobileFormat blockSearchReset">
                <Button id="boutonFiltrer" type="button" className="primary filterButton" onClick={() => afficherRechercheAvancee()} size="small">{<TuneIcon id="iconeFiltrer" />}</Button>
                <Button id="resetSearchForm" type="button" className="primary resetButton" onClick={() => { resetSearchForm(); resetListSatellites({ refreshSatellite }); rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading }) }} size="small">Reset</Button>
              </div>
            </Row>

            <br></br>

            <Row id="rechercheAvancee" className="row-eq-height">
              <div className="col-sm-4 col-md-3">
                <Card className="cardSearch">
                  <Card.Title className="cardTitle"><FormattedMessage id="satelliteFilter" /></Card.Title>
                  <Card.Body>
                    <Form.Select id="orbitalPosition" className="rounded-0 shadow"
                                 onChange={() => { findSatelliteByOrbitalePosition({ onChangeOrbitalPostion }); rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading }) }}
                    >
                      <FormattedMessage id='allOrbitalPositions' key={'op' + '-' + 'a'}>
                        {(message) => <option value=''>{message}</option>}
                      </FormattedMessage>
                      {orbitalePositionData?.filter(orbit => orbit.orbitalPosition != null).map(orbit => (
                          <option value={formatOrbitalPosition(orbit.orbitalPosition).toUpperCase()}>{formatOrbitalPosition(orbit.orbitalPosition)}</option>
                      ))}

                    </Form.Select >
                    <Button type="button" className="satUpdateButton" onClick={() => {
                      findSatelliteByOrbitalePosition({ onChangeOrbitalPostion });
                      rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading });
                    }} style={{display: 'none'}}></Button>
                    <br />
                    <Form.Select id="satellite" className="rounded-0 shadow"
                                 onChange={() => { findOrbitalePositionBySatelliteName({ onChangeSatelliteNameValue }); rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading }) }}>
                      <FormattedMessage id='allSatellites' key={'op' + '-' + 'a'}>
                        {(message) => <option value=''>{message}</option>}
                      </FormattedMessage>
                      {
                        satelitteData.map(satellite => (
                            <option value={satellite.name}>{satellite.name}</option>
                        ))
                      }
                    </Form.Select >
                    <Button type="button" className="orbitUpdateButton" onClick={() => {
                      findOrbitalePositionBySatelliteName({ onChangeSatelliteNameValue });
                      rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading });
                    }} style={{display: 'none'}}></Button>

                    {/* <Button type="button" className="resetListSatellites" size="small"
                      onClick={() => { resetListSatellites({ value, lineUpData, onChangeValue, refreshSatellite }); rechercher({ value, lineUpData, onChangeValue ,onSearchLoading}) }}> <FormattedMessage id="resetListSatellites" /></Button> */}
                  </Card.Body>
                </Card>
              </div>

              <div className="col-sm-4 col-md-3">
                <Card className="cardSearch">
                  <Card.Title className="cardTitle"><FormattedMessage id="contentFilter" /></Card.Title>
                  <Card.Body>
                    <Form.Select id="language" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}>
                      <FormattedMessage id='allLanguages' key={'op' + '-' + 'a'}>
                        {(message) => <option value=''>{message}</option>}
                      </FormattedMessage>
                      {languages.map((language, index) => (
                        <option key={index}>{language}</option>
                      ))}
                    </Form.Select>
                    <br />
                    <Form.Select id="genre" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}>
                      <FormattedMessage id='allGenres' key={'op' + '-' + 'a'}>
                        {(message) => <option value=''>{message}</option>}
                      </FormattedMessage>
                      {themes.map((theme, index) => (
                        <option key={index}>{theme}</option>
                      ))}
                    </Form.Select>
                  </Card.Body>
                </Card>
              </div>

              <div className="col-sm-4 col-md-2">
                <Card className="cardSearch">
                  <Card.Title className="cardTitle"><FormattedMessage id="channelResolution" /></Card.Title>
                  <Card.Body>
                    <Row>
                      <Col>
                        <div className="form-check">
                          <label className="form-check-label" htmlFor="hdCheck">HD
                            <input className="form-check-input" type="checkbox" id="hdCheck" name="channelResolution" value="HD" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}></input>
                          </label>
                        </div>
                        <div className="form-check">
                          <label className="form-check-label" htmlFor="sdCheck">SD
                            <input className="form-check-input" type="checkbox" id="sdCheck" name="channelResolution" value="SD" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}></input>
                          </label>
                        </div>
                      </Col>
                      <Col>
                        <div className="form-check">
                          <label className="form-check-label" htmlFor="uhdCheck">UHD
                            <input className="form-check-input" type="checkbox" id="uhdCheck" name="channelResolution" value="UHD" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}></input>
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-sm-4 col-md-2">
                <Card className="cardSearch">
                  <Card.Title className="cardTitle"><FormattedMessage id="channelEncryption" /></Card.Title>

                  <Card.Body>
                    <div className="form-check">
                      <label className="form-check-label" htmlFor="freeToAirCheck"><FormattedMessage id="formRechercheFreeToAir" />
                        <input className="form-check-input" type="checkbox" id="freeToAirCheck" name="channelEncryption" value="Clear" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}></input>
                      </label>
                    </div>
                    <div className="form-check">
                      <label className="form-check-label" htmlFor="encodedCheck"><FormattedMessage id="formRechercheEncoded" />
                        <input className="form-check-input" type="checkbox" id="encodedCheck" name="channelEncryption" value="Encrypted" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}></input>
                      </label>
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-sm-4 col-md-2">
                <Card className="cardSearch">
                  <Card.Title className="cardTitle"><FormattedMessage id="serviceType" /></Card.Title>
                  <Card.Body>
                    <div className="form-check">
                      <label className="form-check-label" htmlFor="tvCheck">TV
                        <input className="form-check-input" type="checkbox" id="tvCheck" name="serviceType" value="TV" defaultChecked={true} onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}></input>
                      </label>
                    </div>
                    <div className="form-check">
                      <label className="form-check-label" htmlFor="radioCheck">Radio
                        <input className="form-check-input" type="checkbox" id="radioCheck" name="serviceType" value="radio" onChange={() => rechercher({ value, lineUpData, onChangeValue, onSearchLoading,searchLoading })}></input>
                      </label>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Row>
          </Form>
        </Container>
      </I18nPropvider>
    </Root >
  );
}

export default FormulaireRecherche;

